import type { ReactNode } from 'react';
import { useLayoutEffect } from 'react';
import clsx from 'clsx';
import { useVirtualRowRemeasure } from './VirtualRowRemeasureContext';
import './ExpandableVerticalSlice.css';

export interface ExpandableVerticalSliceProps {
  expanded: boolean;
  children: ReactNode;
  className?: string;
}

/** Раскрытие 0fr → 1fr без анимации; remeasure строки в layout — TanStack Virtual. */
export function ExpandableVerticalSlice({ expanded, children, className }: ExpandableVerticalSliceProps) {
  const remeasureRow = useVirtualRowRemeasure();

  useLayoutEffect(() => {
    remeasureRow?.();
  }, [expanded, remeasureRow]);

  return (
    <div
      className={clsx(
        'projects-table__expandable-slice',
        expanded && 'projects-table__expandable-slice_expanded',
        className,
      )}
    >
      <div className="projects-table__expandable-slice-inner">{children}</div>
    </div>
  );
}
